// Container imports
const BannerSectionRecord = require('./record')
// Sibling imports
const { SHOW_BANNER } = require('./actions')

function bannerSectionReducer(state = new BannerSectionRecord(), action) {
  const { type, payload } = action
  switch (type) {
    case SHOW_BANNER:
      return new BannerSectionRecord({ domain: payload })
    default:
      return state
  }
}

module.exports = bannerSectionReducer
